<template>
    <el-dialog
            width="60%"
            :title="$t('HISTORY')"
            visible
            append-to-body
            @close="onCancel"
    >
        <el-table
                max-height="500"
                border
                :row-class-name="tableRowClassName"
                :data="tableData">
            <el-table-column
                    prop="name"
                    min-width="150"
                    show-overflow-tooltip
                    class-name="file-name-cell"
                    :label="$t('DOWNLOAD_FILE_NAME')">
                <template
                        slot-scope="scope"
                >
                    <!-- 客户之间不允许相互下载 || 没有下载权限 -->
                    <span v-if="calcDisableDownload(scope.row)">{{scope.row.name}}</span>
                    <span v-else class="file-name can-download" @click="onFileDownload(scope.row)">
                        <i class="el-icon-download"/>
                        {{scope.row.name}}
                  </span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="size"
                    show-overflow-tooltip
                    :label="$t('DOWNLOAD_SIZE')">
                <template
                        slot-scope="scope">
                    <span>{{scope.row.size | fileSize}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="downloadDate"
                    width="125"
                    show-overflow-tooltip
                    :label="$t('DOWNLOAD_TIME')">
            </el-table-column>
            <el-table-column
                    prop="downloadBy"
                    width="125"
                    show-overflow-tooltip
                    :label="$t('DOWNLOAD_BY')">
            </el-table-column>
            <el-table-column
                    prop="uploadDate"
                    width="125"
                    show-overflow-tooltip
                    :label="$t('UPLOAD_TIME')">
            </el-table-column>
            <el-table-column
                    prop="uploadBy"
                    show-overflow-tooltip
                    :label="$t('UPLOAD_BY')">
                <template slot-scope="scope">
                    {{ scope.row.uploadBy ==='System synchronisation'?$t('admin.System synchronisation') : scope.row.uploadBy}}
                </template>
            </el-table-column>
            <el-table-column
              prop="action"
              width="70"
              show-overflow-tooltip
              
              :label="$t('COMMON_DELETE')">
                <template
                  slot-scope="scope"
                >
                    <!-- 已接受条目不可删除 || 毕马威不可删除客户上传的文件 || 客户也不可删除毕马威上传的文件 -->
                    <i class="el-icon-delete delete" v-if="!noAuthority(scope.row)" @click="onDeleteClick(scope.row)"/>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
    import {mapGetters} from "vuex"
    import API from '@/api'
    import { userPermission } from '@/mixins/userPermission.js'

    export default {
        name: "file-history",
        props: {
            tableData: Array,
            onCancel: Function,
            curUserName: String,
            downloadAble: Boolean,
        },
        mixins: [userPermission],
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getSite: 'getSite'
            })
        },
        methods: {
            noAuthority(file) {
                return file.uploadBy && file.uploadBy.indexOf('@') === -1 && this.getUser.userType === '2' ||
                  file.uploadBy && file.uploadBy.indexOf('@') !== -1 && this.getUser.userType === '1'
            },
            calcDisableDownload(row) {
                return !this.hasPermission('download') ||
                        this.getUser.userType === '2' &&
                        !this.downloadAble &&
                        row.uploadBy &&
                        row.uploadBy.indexOf('@') !== -1
            },
            onDeleteClick(row) {
                const params = {
                    fileId: row.fileId,
                    id: row.groupEntityTopicId,
                    fileNameList: [row.name],
                    source: 'exchange',
                    ifDeleteHistory: false,
                    siteId: this.getSite.siteId
                }
                this.$confirm(this.$t('FILE_DELETE_WARNING_MSG_ONLY'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                }).then(() => {
                    // 删除----
                    API.clientAdmin.deleteUploadFiles(params).then((res) => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.$emit("queryFileHistory",row)
                            // this.tableData.splice(this.tableData.findIndex(v => v.fileId == row.fileId), 1)
                            // if(this.tableData.length === 0) {
                            //     this.$emit("clearHistoryFlag", row)
                            // }
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                })
            },
            onFileDownload (row) {
                this.$emit('on-file-download', row);
            },
            tableRowClassName({row, rowIndex}){
                if (row.uploadBy && row.uploadBy.indexOf('@') === -1) {
                    return 'kp-update-row';
                }
                return '';
            },
        }
    }
</script>

<style scoped>
    .file-name-cell .can-download {
        cursor: pointer;
        user-select: none;
    }
    .file-name-cell .file-name {
        display: inline-block;
        margin-right: 10px;
    }

    .file-name-cell .can-download:hover {
        color: rgb(120, 120, 195);
        text-decoration: underline;
    }
    ::v-deep .kp-update-row {
       background: #0091da;
       color: #FFFFFF;
    }
    ::v-deep .el-table tr:hover{
        color: #636363;
    }
    .delete {
        color: #fd349c;
        cursor: pointer;
    }
    .el-icon-download {
        color: #3879EB;
    }
</style>
